import { styled } from '@mui/material/styles';
import { tooltipClasses, Tooltip } from '@mui/material';
import { COLOR } from '@src/styles/color';
import { BREAKPOINTS } from '@src/styles/config';

export const StyledReferralStats = styled('div')`
  .referral-stats-container {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
      margin-top: 0px;
      gap: 8px;
    }
  }

  .referral-stats {
    display: flex;
    flex-direction: row;
    gap: 16px;

    @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
      flex-direction: column;
    }
  }

  .title-text {
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;

    @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export const StatCardWrapper = styled('div')`
  display: flex;
  flex: 1;
  background: ${COLOR.white};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 39px 0;
  gap: 4px;
  border: 1px solid ${COLOR.darkV2[16]};
  position: relative;

  .stat-card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
  }

  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    flex-direction: column;
    justify-content: space-between;
    padding: 12px 16px;
    gap: 16px;
    border-radius: 8px;

    .stat-card-content {
      display: flex;
      width: 100%;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
    }
  }

  .gift-wrapper {
    display: flex;
    justify-content: center;
    position: absolute;
    top: 16px;
    right: 16px;

    @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
      position: relative;
      width: 100%;
      top: 0;
      right: 0;
    }

    .gift-button {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 12px;
      width: 40px;
      height: 40px;
      background-color: ${COLOR.primary};
      cursor: pointer;
      gap: 10px;

      .gift-text {
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        color: ${COLOR.darkBlue};
      }

      @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
        width: 100%;
      }

      .dot-of-gift {
        position: absolute;
        top: -6px;
        right: -6px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background-color: ${COLOR.red};
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        line-height: 16px;
        color: ${COLOR.white};
        border: 2px solid ${COLOR.white};
      }
      .gift-icon {
        width: 16px !important;
        height: 16px !important;
      }
    }
  }
`;

export const StatValue = styled('div')`
  color: ${({ isHighlight }) => (isHighlight ? COLOR.blueV2 : COLOR.darkGray)};
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;

  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }
`;

export const StatLabel = styled('div')`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: ${COLOR.label2[64]};
  text-align: center;

  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
`;

export const StyledReferralRedeemContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;

  .referral-reward-title {
    color: ${COLOR.darkGray};
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: -0.4px;
    text-align: center;
  }

  .redeem-character-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
  }

  .character-counter-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    height: 48px;
  }

  .redeemed-character-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    justify-content: flex-start;
  }

  .redeemed-character-text {
    color: ${({ hasReachedMaxRedeemCharacter }) =>
      hasReachedMaxRedeemCharacter ? COLOR.red : COLOR.darkGray};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.4px;
    vertical-align: middle;
  }

  .character-counter {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    height: 100%;
    border-radius: 12px;
    background: ${COLOR.charcoal};
  }

  .character-counter-text {
    color: ${COLOR.darkGray};
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: -0.4px;
  }

  .character-text-lower {
    color: ${COLOR.label2[64]};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  .decrease-button,
  .increase-button {
    color: ${COLOR.darkGray};
    border-radius: 12px;
    border: 1px solid rgba(60, 60, 67, 0.16);
    max-width: 48px;
    max-height: 48px;
    min-width: 48px;
    min-height: 48px;
  }

  .info-box {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    vertical-align: middle;
    color: ${COLOR.darkGray};
  }
`;

export const StyledReferralCannotRedeemContent = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  .cannot-redeem-text {
    color: ${COLOR.darkGray};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
`;

export const StyledTooltip = styled(({ className, ...props }) => (
  // eslint-disable-next-line react/jsx-filename-extension, react/react-in-jsx-scope
  <Tooltip {...props} classes={{ popper: className }} placement="top" />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: COLOR.label[80],
    color: COLOR.white,
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 400,
    padding: '8px 16px',
    textAlign: 'center',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: COLOR.label[80],
  },
}));

export const StyledStatBanner = styled('div')`
  margin-top: 24px;
  padding: 24px;
  gap: 16px;
  max-height: 88px;
  display: flex;
  border: 1px solid ${COLOR.borderPromoEarnings};
  background-color: ${COLOR.backgroundPromoEarnings};
  border-radius: 16px;
  box-sizing: border-box;
  justify-content: space-between;

  .banner-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .content-button-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    justify-content: flex-end;
  }

  .banner-content-container {
    display: flex;
    align-items: center;
    gap: 16px;

    @media only screen and (max-width: ${BREAKPOINTS.SMD}px) {
      gap: 8px;
    }
  }

  @media only screen and (max-width: ${BREAKPOINTS.SMD}px) {
    max-height: 108px;
    padding: 12px;
    .banner-content-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
    .banner-content-title {
      font-size: 12px;
    }
    .banner-content-value {
      font-size: 20px;
    }
    .banner-content {
      gap: 0px;
    }
  }

  .gift-button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    width: max-content;
    height: 40px;
    cursor: pointer;
    gap: 10px;

    .gift-text {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      color: ${COLOR.darkBlue};
    }

    @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
      width: 100%;
      justify-content: flex-end;
    }

    .dot-of-gift {
      position: absolute;
      top: -6px;
      right: -6px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: ${COLOR.red};
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 10px;
      line-height: 16px;
      color: ${COLOR.white};
      border: 2px solid ${COLOR.white};
      z-index: 100;
    }
  }
  .gift-icon {
    width: 20px;
    height: 20px;
    padding: 10px;
    background-color: ${COLOR.primary};
    border-radius: 8px;

    @media only screen and (max-width: ${BREAKPOINTS.SMD}px) {
      box-sizing: border-box;
      width: 32px !important;
      height: 32px !important;
      padding: 8px;
    }
  }
`;
